import { pipe, pluck, flatten, uniq, curry } from "ramda";
import { getPeriod } from "utils/periods";
import { defaultDates } from "utils/dates";
import { getRelativeTo } from "utils/measurement";
import { isNotEmptyArray, valueBearing } from "utils/validation";
export var getAdjustedMeasuresMetadata = function getAdjustedMeasuresMetadata(measures, query) {
  var _getPeriod, _getPeriod2;
  var periodTypes = pipe(pluck("periodTypes"), flatten, uniq)(measures);
  var periodType = !periodTypes.includes(query.periodType) ? periodTypes[0] : query.periodType || periodTypes[0];
  return {
    earliestDataDate: (_getPeriod = getPeriod(periodType, defaultDates.earliestDataDate)) === null || _getPeriod === void 0 ? void 0 : _getPeriod.start,
    lastDataDate: (_getPeriod2 = getPeriod(periodType, defaultDates.lastDataDate)) === null || _getPeriod2 === void 0 ? void 0 : _getPeriod2.end,
    periodTypes: periodTypes
  };
};
export var soughtValueIcons = {
  "Ej angivet": null,
  Högt: "trendUp",
  Lågt: "trendDown"
};
var byRelativeFilter = function byRelativeFilter(relativeFilter, relativeValue) {
  return (relativeFilter === null || relativeFilter === void 0 ? void 0 : relativeFilter.length) > 0 ? relativeFilter.includes(relativeValue) : true;
};
var invalidReasonCodes = ["UNK", "MSK", "INV", "NI"];
var getEffectiveRelativeValue = function getEffectiveRelativeValue(measure, measurements, relativeTo, organizationId) {
  var _measure$soughtValue, _measure$targetMeasur;
  if (!measurements) return null;
  var latest = measurements[0];
  var previous = measurements[1];
  var hasSoughtValue = !((_measure$soughtValue = measure.soughtValue) !== null && _measure$soughtValue !== void 0 && _measure$soughtValue.includes("Kan ej anges"));
  var hasTargetMeasurements = ((_measure$targetMeasur = measure.targetMeasurements) === null || _measure$targetMeasur === void 0 ? void 0 : _measure$targetMeasur.length) > 0;
  var relevantMeasurement = relativeTo === "se" ? latest : previous;
  var relativeToValue = getRelativeTo(null, relativeTo, latest, previous, measure.soughtValue);
  if (!relevantMeasurement || invalidReasonCodes.includes(relevantMeasurement === null || relevantMeasurement === void 0 ? void 0 : relevantMeasurement.reasonCode)) {
    relativeToValue = null;
  } else if (organizationId !== "SE" && relativeToValue === null) {
    relativeToValue = 0;
  }
  var hasColor = hasSoughtValue && (relativeTo !== "goalValue" || hasTargetMeasurements) && valueBearing(relativeToValue);
  if (!hasColor) return null;
  return relativeToValue >= 0 ? 1 : -1;
};
export var filterMeasuresByRelativeTo = curry(function (measures, measurementsWithMetadata, organizationId, relativeFilter, relativeTo) {
  return measures.filter(function (measure) {
    var _entry$;
    var entry = measurementsWithMetadata.get("".concat(measure.measureId, "-").concat(organizationId)) || [];
    var measurements = (_entry$ = entry[0]) === null || _entry$ === void 0 ? void 0 : _entry$.measurements;
    var relativeToValue = getEffectiveRelativeValue(measure, measurements, relativeTo, organizationId);
    return byRelativeFilter(relativeFilter, relativeToValue);
  });
});
export var filterMeasuresByHasMeasurements = curry(function (measures, measurementsWithMetadata) {
  return measures.filter(function (measure) {
    var entry = measurementsWithMetadata.get("".concat(measure.measureId)) || [];
    var measurements = pluck("measurements", entry).flat();
    return isNotEmptyArray(measurements);
  });
});